export { default } from "ember-power-select/components/power-select-multiple/input";
